"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDevHostname = exports.getDevPort = exports.getDevPortOffset = void 0;
const error_1 = require("./error");
const utils = __importStar(require("./utils"));
const defaultDevPorts = {
    coreFrontend: 4000,
    adminFrontend: 4001,
    coreBackend: 8000,
    adminBackend: 8001,
};
const getDevPortOffset = () => {
    const raw = utils.EnvUtils.isBackend()
        ? process.env.ATLAS_PORT_OFFSET
        : globalThis.ATLAS_PORT_OFFSET;
    if (raw === undefined || raw === '')
        return 0;
    // Multiples of 10 below 1000 keep the four ports apart and clear of the
    // other local services (api gateway on 9000, impl-agent on 13000). Same
    // check as scripts/launch-dev-tabs.sh.
    (0, error_1.finleyAssert)(/^(0|[1-9]\d?0)$/.test(raw), `ATLAS_PORT_OFFSET must be a multiple of 10 from 0 to 990, got "${raw}"`);
    return Number(raw);
};
exports.getDevPortOffset = getDevPortOffset;
const getDevPort = (server) => defaultDevPorts[server] + (0, exports.getDevPortOffset)();
exports.getDevPort = getDevPort;
const getDevHostname = (server) => `localhost:${(0, exports.getDevPort)(server)}`;
exports.getDevHostname = getDevHostname;
//# sourceMappingURL=devPorts.js.map